import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '@/config/config.js'

import Home from '../pages/Home.vue'
import layout from '../pages/layout.vue'
// import Program from '../pages/program.vue'
// import ProgramSec from '../pages/program-sec.vue'
// import productDetail from '../pages/program-detail.vue'
// import Artist from '../pages/artist.vue'
// import ArtistDetail from '../pages/artist-detail.vue'
// import Thematic from '../pages/thematic.vue'
// import ThematicDetail from '../pages/thematic-detail.vue'
// import Activity from '../pages/activity.vue'
// import ActivityDetail from '../pages/activity-detail.vue'
// import Award from '../pages/award.vue'
// import News from '../pages/news.vue'
// import NewsDetail from '../pages/news-detail.vue'
// import Search from '../pages/search.vue'
import Guid from '../pages/guid.vue'
// import notFound  from "../pages/notFound.vue"

var baseTitle = process.env.NODE_ENV==='production'? window.baseTitle :config.baseTitle;

// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve && onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
  // return originalPush.call(this, location,()=>{},()=>{})
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location,onResolve,onReject){
  if(onResolve || onReject) return originalReplace.call(this,location,onResolve,onReject)
  return originalReplace.call(this,location).catch(err=>err)
}

const routes = [
  {
    path: '/',
    name: 'layout',
    component: layout,
    // redirect: 'Guid',
    redirect: 'guid',
    meta: {
      title: baseTitle,
      keepAlive: true // 需要缓存
    },
    children: [
      {
        path: '/index',
        component: Home,
        name:'index',
        meta: {
          title: baseTitle,
          index:0,
        }
      },
      {
        path: '/program',
        name: 'Program',
        // component: Program,
        component:()=>import ("@/pages/program/index.vue"),
        meta: {
          title: '节目库-'+baseTitle,
          index:1
        },
      },
      {
        path: '/test',
        name: 'Test',
        // component: Program,
        component:()=>import ("@/pages/program/test.vue"),
        meta: {
          title: 'test',
          hideTop:true,
          hideFooter:true,
          index:1
        },
      },
      // {
      //   path:'/program/:catename',
      //   name:'节目库分类',
      //   // component:ProgramSec,
      //   component:()=>import ("@/pages/program-sec.vue"),
      //   meta: {
      //     title:  '节目库-'+baseTitle,
      //     index:2
      //   },
      // },
      {
        path:'/program/:id/:access?', //(\\d*[02468])偶数
        name:'节目库详情',
        // component: productDetail,
        component:()=>import ("@/pages/program/details.vue"),
        meta: {
          title: '节目库-'+baseTitle,
          index:3,
          detailPage:true
        },
      },
      {
        path: '/preview/:id/:token', //(\\d*[02468])偶数
        name: '节目库详情',
        // component: productDetail,
        component: () => import("@/pages/preview.vue"),
        meta: {
          title: '节目库-' + baseTitle,
          index: 3,
          detailPage:true
        },
      },
      {
        path: '/artist',
        name: 'Artist',
        // component: Artist,
        component:()=>import ("@/pages/artist.vue"),

        meta: {
          title: '人才库-'+baseTitle,
          index:1,
          // keepAlive:true
        } 
      },
      {
        path: '/artist/:id',
        name: '人才库详情',
        component:()=>import ("@/pages/artist-detail.vue"),
        // component: ArtistDetail,
        meta: {
          title: '人才库-'+baseTitle,
          index:2,
          detailPage:true
        } 
      },

      // {
      //   path: '/thematic',
      //   name: 'Thematic',
      //   component:()=>import ("@/pages/thematic.vue"),
      //   // component: Thematic,
      //   meta: {
      //     title: '活动库-'+baseTitle,
      //     index:1
      //   } 
      // },
      {
        path: '/thematic/:id',
        name: 'thematicDetail',
        component:()=>import ("@/pages/activity/thematic-detail.vue"),
        // component:ThematicDetail,
        meta: {
          title: '活动库-'+baseTitle,
          index:2,
          detailPage:true
        } 
      },
      
      {
        path: '/activity',
        name: 'Activity',
        component:()=>import ("@/pages/activity/index.vue"),
        // component: Activity,
        meta: {
          title: '活动库-'+baseTitle,
          index:1
        } 
      },
      {
        path: '/activity/:id',
        name: '活动库详情',
        component:()=>import ("@/pages/activity/activity-detail.vue"),
        // component: ActivityDetail,
        meta: {
          title: '活动库-'+baseTitle,
          index:2,
          detailPage:true
        } 
      },
      {
        path: '/award',
        name: 'Award',
        component:()=>import ("@/pages/award.vue"),
        // component: Award,
        meta: {
          title: '获奖库-'+baseTitle,
          index:1
        } 
      },
      {
        path: '/news',
        name: 'News',
        component:()=>import ("@/pages/news.vue"),
        // component: News,
        meta: {
          title: '新闻中心-'+baseTitle,
          index:1
        },
        
      },
      {
        path: '/news/:id',
        name: 'newsDetail',
        component:()=>import ("@/pages/news-detail.vue"),
        // component: NewsDetail,
        meta: {
          title: '新闻中心-'+baseTitle,
          index:2,
          detailPage:true
        } 
      },
      {
        path: '/preview-news/:id/:token',
        name: 'newsDetail',
        component: () => import("@/pages/preview-news.vue"),
        // component: NewsDetail,
        meta: {
          title: '新闻中心-' + baseTitle,
          index: 2,
          detailPage:true
        }
      },
      {
        path: '/search',
        name: 'search',
        component:()=>import ("@/pages/search.vue"),
        // component:Search,
        meta: {
          title: '搜索-'+baseTitle,
          index:1
        } 
      },
      {
        path: '/advice',
        name: 'advice',
        component:()=>import ("@/pages/advice.vue"),
        // component:Search,
        meta: {
          title: '意见反馈-'+baseTitle,
          index:1
        } 
      },
      {
        path:'/login/:toPage?',
        name:'login',
        component:()=> import ("@/pages/login.vue"),
        meta:{
          title:"登录-"+baseTitle
        }
      },
      {
        path:'/bind/:toPage?',
        name:'bind',
        component:()=> import ("@/pages/bind.vue"),
        meta:{
          title:"绑定手机-"+baseTitle
        }
      },
      {
        path: '/register/:toPage?',
        name: 'register',
        component: () => import("@/pages/register.vue"),
        meta: {
          title: "注册-" + baseTitle
        }
      },
      {
        path: '/findPassword',
        name: 'findPassword',
        component: () => import("@/pages/findPwd.vue"),
        meta: {
          title: "找回密码-" + baseTitle
        }
      },
      {
        path: '/exhibit',
        name: 'Exhibit',
        // component: Artist,
        component:()=>import ("@/pages/exhibit/index.vue"),

        meta: {
          title: '展品库-'+baseTitle,
          index:1,
          // keepAlive:true
        } 
      },
      // {
      //   path:'/exhibit/:catename',
      //   name:'展品库分类',
      //   component:()=>import ("@/pages/exhibit/sec.vue"),
      //   meta: {
      //     title:  '展品库-'+baseTitle,
      //     index:2
      //   },
      // },
      {
        path: '/exhibit/:id/:access?',
        name: '展品库详情',
        component:()=>import ("@/pages/exhibit/details.vue"),
        // component: ArtistDetail,
        meta: {
          title: '展品库-'+baseTitle,
          index:3,
          detailPage:true
        } 
      },
      {
        path: '/poster',
        name: 'Poster',
        component:()=>import ("@/pages/poster/index.vue"),

        meta: {
          title: '海报库-'+baseTitle,
          index:1,
          // keepAlive:true
        } 
      },
      {
        path: '/poster/:id/:access?',
        name: '海报库详情',
        component:()=>import ("@/pages/poster/details.vue"),
        // component: ArtistDetail,
        meta: {
          title: '海报库-'+baseTitle,
          index:2,
          detailPage:true
        } 
      },
      {
        path:"/literature",
        name:"literature",
        component: () => import("@/pages/literature/index.vue"),
        meta:{
          title:"文学库-"+baseTitle
        }
      },
      // {
      //   path: '/literature/:catename',
      //   name: 'literature-sec',
      //   component: () => import("@/pages/literature/literature-sec.vue"),
      //   meta: {
      //     title: '文学库-' + baseTitle,
      //     index: 2
      //   },
      // },
      {
        path: '/literature/:id/:access?',
        name: 'literature-detail',
        component: () => import("@/pages/literature/details.vue"),
        meta: {
          title: '文学库-' + baseTitle,
          index: 2
        },
      },
      {
        path: '/book/:id(\\d+)/:access?',
        name: 'book',
        component: () => import("@/pages/literature/book.vue"),
        meta: {
          title: '文学库-' + baseTitle,
          index: 2
        },
      },
      {
        path: '/book/read/:id',
        name: 'bookRead',
        component: () => import("@/pages/literature/book-read.vue"),
        meta: {
          title: '文学库-' + baseTitle,
          hideTop: true,
          hideFooter:true
        },
      },
      {
        path:'/user',
        name:'user',
        component:()=> import ("@/pages/user/index.vue"),
        meta:{
          title:"我的-"+ baseTitle,
          hideTop:true,
        }
      }
    ]  
  },
  {
    path:"/guid",
    name:'Guid',
    component: Guid,
    meta:{
      title: baseTitle,
    }
  },
  {
    path:"/:path(.*)",
    name:'notFound',
        component:()=>import ("@/pages/notFound.vue"),
        // component: notFound
  },

]

const router = new VueRouter({
  mode: 'hash',  //或者hash
  base: process.env.BASE_URL,
  routes,
  // history:createWebHashHistory(process.env.BASE_URL),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router